export enum FAILURE_REASONS {
	INSUFFICIENT_FUNDS='No logramos realizar el cobro de tu renovación por falta de fondos en tu método de pago. Por favor agrega fondos a tu cuenta o cambia tu método de pago.',
}